import clsx from "clsx";
import { Text } from "@repo/ui/text";
import classes from "./inline-message.module.css";

export type InlineMessageVariant = "standard" | "success" | "error" | "subtle";

export type InlineMessageAppearance = "inline" | "bordered" | "banner";

export type InlineMessageProps = {
  children: React.ReactNode;
  variant?: InlineMessageVariant;
  appearance?: InlineMessageAppearance;
  icon?: React.ReactNode;
  closeIcon?: React.ReactNode;
  maxLines?: number;
  className?: string;
  style?: React.CSSProperties;
  role?: "status" | "alert";
  onDismiss?: () => void;
  dismissLabel?: string;
  inlineMessageClass?: string;
};

export const InlineMessage = ({
  children,
  variant = "standard",
  appearance = "inline",
  icon,
  closeIcon,
  maxLines,
  className,
  style,
  role,
  onDismiss,
  dismissLabel,
  inlineMessageClass,
}: InlineMessageProps) => {
  const ariaRole = role ?? (variant === "error" ? "alert" : "status");

  return (
    <div
      className={clsx(
        classes.root,
        classes[`variant-${variant}`],
        classes[`appearance-${appearance}`],
        className,
      )}
      style={style}
      role={ariaRole}
    >
      {icon}
      <Text
        maxLines={maxLines}
        className={clsx(classes.text, inlineMessageClass)}
      >
        {children}
      </Text>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className={classes.dismiss}
          aria-label={dismissLabel}
        >
          {closeIcon}
        </button>
      )}
    </div>
  );
};
